// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"265":"Settings","328":"admin","362":"Dashboard","596":"404","723":"Manager","818":"auth"}[chunkId] || chunkId) + "." + {"265":"a5b55fe2","328":"7b9c46fd","358":"3c135dab","362":"ff62c73d","596":"60ebf575","723":"aece0ce9","818":"5b786f45"}[chunkId] + ".js";
};